import { PageShell, Block } from "./PageShell";

export default function Guidelines() {
  return (
    <PageShell
      title="Community Guidelines"
      intro="HEARD is a space for healing, growth, and real human connection. These guidelines keep every space safe and supportive."
    >
      <Block heading="1. Lead with empathy">
        <p>Listen first. Respond with kindness. Everyone here is carrying something — meet people where they are.</p>
      </Block>
      <Block heading="2. Protect anonymity">
        <p>Respect the anonymity of others. Never attempt to identify, expose, or contact members outside of HEARD.</p>
      </Block>
      <Block heading="3. Keep it safe">
        <p>No harassment, hate, bullying, or harmful content. We have zero tolerance for cruelty of any kind.</p>
      </Block>
      <Block heading="4. Support, don't diagnose">
        <p>Share your experience and encouragement, but HEARD is not a substitute for professional care. In a crisis, please use our Support Center resources.</p>
      </Block>
      <Block heading="5. No spam or self-promotion">
        <p>This is a community, not a marketplace. Keep the space free of advertising, solicitation, and off-topic promotion.</p>
      </Block>
      <Block heading="Reporting">
        <p>If something doesn't feel right, report it. Our moderators review reports to keep HEARD warm and welcoming for everyone.</p>
      </Block>
    </PageShell>
  );
}
